(function(){'use strict';

function hideDawnHeader(){
  var selectors=['.shopify-section-group--header-group','#shopify-section-header','header.header','.header-wrapper'];
  selectors.forEach(function(sel){var el=document.querySelector(sel);if(el)el.style.display='none';});
  document.documentElement.style.setProperty('--header-height','0px');
}

function initGallery(){
  var mainImg=document.getElementById('pdp-main-img');
  var thumbs=document.querySelectorAll('.pdp-gallery__thumb');
  var prevBtn=document.getElementById('pdp-gallery-prev');
  var nextBtn=document.getElementById('pdp-gallery-next');
  if(!mainImg||!thumbs.length)return;
  var images=Array.from(thumbs).map(function(t){return{src:t.dataset.src,alt:t.dataset.alt||''};});
  if(!images.length)return;
  var current=0;
  function goTo(idx){
    current=(idx+images.length)%images.length;
    mainImg.src=images[current].src;
    mainImg.alt=images[current].alt;
    thumbs.forEach(function(t,i){t.classList.toggle('is-active',i===current);});
  }
  thumbs.forEach(function(thumb,i){thumb.addEventListener('click',function(){goTo(i);});});
  if(prevBtn)prevBtn.addEventListener('click',function(){goTo(current-1);});
  if(nextBtn)nextBtn.addEventListener('click',function(){goTo(current+1);});
}

function formatMoney(cents){
  var euros=Math.ceil(cents/100);
  return euros.toLocaleString('fr-FR')+' €';
}

function initSizeSelector(){
  var buttons=document.querySelectorAll('.pdp-size');
  var variantInput=document.getElementById('pdp-variant-id');
  var priceEl=document.getElementById('pdp-price');
  var compareEl=document.getElementById('pdp-compare');
  var savingsEl=document.getElementById('pdp-savings');
  var atcBtn=document.querySelector('.pdp-atc');
  if(!buttons.length||!variantInput)return;
  buttons.forEach(function(btn){
    btn.addEventListener('click',function(){
      if(btn.disabled)return;
      buttons.forEach(function(b){b.classList.remove('is-selected');});
      btn.classList.add('is-selected');
      var variantId=btn.dataset.variantId;
      var variantPrice=parseInt(btn.dataset.price,10);
      var comparePrice=parseInt(btn.dataset.compare,10)||variantPrice;
      var isAvailable=btn.dataset.available!=='false';
      variantInput.value=variantId;
      if(priceEl&&variantPrice){
        var memberPrice=Math.ceil(variantPrice/1.2/100)*100;
        priceEl.textContent=formatMoney(memberPrice);
        if(compareEl)compareEl.textContent=formatMoney(comparePrice);
        if(savingsEl){
          var savings=comparePrice-memberPrice;
          if(savings>0){
            savingsEl.textContent='Économise '+formatMoney(savings);
            savingsEl.style.display='';
          } else {
            savingsEl.style.display='none';
          }
        }
      }
      if(atcBtn){
        if(isAvailable){
          atcBtn.disabled=false;
          atcBtn.textContent='AJOUTER AU PANIER';
          atcBtn.style.background='';
        } else {
          atcBtn.disabled=true;
          atcBtn.textContent='ÉPUISÉ';
        }
      }
    });
  });
}

function initCountdown(){
  var el=document.getElementById('pdp-countdown');
  if(!el)return;
  var ts=parseInt(el.dataset.end,10);
  if(!ts||isNaN(ts))return;
  var endDate=new Date(ts*1000);
  if(isNaN(endDate.getTime()))return;
  function pad(n){return String(n).padStart(2,'0');}
  function tick(){
    var diff=endDate.getTime()-Date.now();
    if(diff<=0){
      var wrap=document.querySelector('.pdp-countdown-wrap');
      if(wrap)wrap.style.display='none';
      return;
    }
    var d=Math.floor(diff/86400000);
    var h=Math.floor((diff%86400000)/3600000);
    var m=Math.floor((diff%3600000)/60000);
    el.textContent=d+'j '+pad(h)+'h '+pad(m)+'m';
  }
  tick();
  setInterval(tick,60000);
}

function initAccordion(){
  var accordions=document.querySelectorAll('.pdp-accordion');
  accordions.forEach(function(accordion){
    var header=accordion.querySelector('.pdp-accordion__header');
    var body=accordion.querySelector('.pdp-accordion__body');
    var icon=accordion.querySelector('.pdp-accordion__icon');
    if(!header||!body)return;
    if(accordion.classList.contains('is-open')){
      body.style.maxHeight=body.scrollHeight+'px';
    } else {
      body.style.maxHeight='0';
    }
    header.addEventListener('click',function(){
      var isOpen=accordion.classList.contains('is-open');
      if(isOpen){
        accordion.classList.remove('is-open');
        body.style.maxHeight='0';
        if(icon)icon.textContent='+';
      } else {
        accordion.classList.add('is-open');
        body.style.maxHeight=body.scrollHeight+'px';
        if(icon)icon.textContent='−';
      }
    });
  });
}

function initBurger(){
  var burger=document.getElementById('drop-nav-burger');
  var menu=document.getElementById('drop-mobile-menu');
  var closeBtn=document.getElementById('drop-mobile-menu-close');
  if(!burger||!menu)return;
  function openMenu(){menu.classList.add('is-open');burger.classList.add('is-open');burger.setAttribute('aria-expanded','true');document.body.style.overflow='hidden';}
  function closeMenu(){menu.classList.remove('is-open');burger.classList.remove('is-open');burger.setAttribute('aria-expanded','false');document.body.style.overflow='';}
  burger.addEventListener('click',function(){menu.classList.contains('is-open')?closeMenu():openMenu();});
  if(closeBtn)closeBtn.addEventListener('click',closeMenu);
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&menu.classList.contains('is-open'))closeMenu();});
}

function init(){
  hideDawnHeader();
  initGallery();
  initSizeSelector();
  initCountdown();
  initAccordion();
  initBurger();
}

if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();
